import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, MessageCircle, ArrowUpRight, Shield, Cpu } from "lucide-react";

const footerLinks = {
  Services: [
    { label: "CCTV Systems", path: "/products" },
    { label: "Alarm Systems", path: "/products" },
    { label: "Smart Home", path: "/products" },
    { label: "Starlink Internet", path: "/products" },
    { label: "Networking", path: "/products" },
    { label: "Annual Maintenance", path: "/services" },
  ],
  Company: [
    { label: "About Us", path: "/about" },
    { label: "Services", path: "/services" },
    { label: "Projects", path: "/projects" },
    { label: "Brands", path: "/brands" },
    { label: "Warranty Check", path: "/warranty" },
    { label: "Contact", path: "/contact" },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-brand-dark text-white">
      <div className="section-padding">
        <div className="container-custom">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-16">
            {/* Brand */}
            <div className="lg:col-span-2">
              <Link to="/" className="flex items-center gap-2 group mb-6">
                <div className="w-10 h-10 bg-brand-orange rounded-xl flex items-center justify-center">
                  <span className="text-white font-bold text-lg">K</span>
                </div>
                <span className="font-display text-xl font-bold">
                  K-Tec<span className="text-brand-orange">.lk</span>
                </span>
              </Link>
              <p className="text-white/60 leading-relaxed max-w-md mb-8">
                Professional Security & Technology Solutions across Sri Lanka.
                Smart Security. Modern Living.
              </p>
              <div className="flex flex-col gap-3">
                <a href="tel:+94762829800" className="flex items-center gap-3 text-white/60 hover:text-white transition-colors">
                  <Phone size={18} />
                  <span>076 282 9800</span>
                </a>
                <a href="https://wa.me/94702161323" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-white/60 hover:text-white transition-colors">
                  <MessageCircle size={18} />
                  <span>070 216 1323</span>
                </a>
                <a href="mailto:info@k-tec.lk" className="flex items-center gap-3 text-white/60 hover:text-white transition-colors">
                  <Mail size={18} />
                  <span>info@k-tec.lk</span>
                </a>
                <div className="flex items-center gap-3 text-white/60">
                  <MapPin size={18} />
                  <span>Kandy, Sri Lanka</span>
                </div>
              </div>
            </div>

            {/* Links */}
            {Object.entries(footerLinks).map(([title, links]) => (
              <div key={title}>
                <h3 className="font-semibold text-white mb-5 text-sm uppercase tracking-wider">
                  {title}
                </h3>
                <ul className="flex flex-col gap-3">
                  {links.map((link) => (
                    <li key={link.label}>
                      <Link
                        to={link.path}
                        className="text-white/50 hover:text-white transition-colors text-sm flex items-center gap-1 group"
                      >
                        {link.label}
                        <ArrowUpRight
                          size={14}
                          className="opacity-0 -translate-y-1 translate-x-1 group-hover:opacity-100 group-hover:translate-y-0 group-hover:translate-x-0 transition-all"
                        />
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}

            {/* Trust */}
            <div>
              <h3 className="font-semibold text-white mb-5 text-sm uppercase tracking-wider">
                Trust & Quality
              </h3>
              <div className="flex flex-col gap-4">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-xl bg-white/10 flex items-center justify-center">
                    <Shield size={20} className="text-brand-orange" />
                  </div>
                  <div>
                    <p className="text-sm font-medium text-white/80">Warranty Guaranteed</p>
                    <p className="text-xs text-white/40">2-3 Year Coverage</p>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-xl bg-white/10 flex items-center justify-center">
                    <Cpu size={20} className="text-brand-orange" />
                  </div>
                  <div>
                    <p className="text-sm font-medium text-white/80">Expert Installation</p>
                    <p className="text-xs text-white/40">Certified Technicians</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Bottom */}
          <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-white/40 text-sm">
              © 2025 K-Tec.lk. All rights reserved.
            </p>
            <p className="text-white/40 text-sm">
              Smart Security. Modern Living.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
